import propsResolver from "@insightfulscience/shared-utils/fn/props-resolver";

import sets from "@src/Plasmids/providers/getPlasmidSets";

export default propsResolver({
	sets,
});
